/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export const findEdgeIndex = (graph, spec) => {
    return graph.edges.findIndex((edge) => {
        return edgesEqual(spec, edge);
    });
};
export const edgesEqual = (a, b) => {
    return (a.from === b.from &&
        a.to === b.to &&
        a.out === b.out &&
        a.in === b.in &&
        b.constant === b.constant);
};
//# sourceMappingURL=edge.js.map